import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Form, Upload, Icon, message } from 'antd';
const FormItem = Form.Item;
const Dragger = Upload.Dragger;

const props = {
    name: 'file',
    multiple: false,
    beforeUpload(file, fileList) {

        const isLt2M = file.size / 1024 / 1024 < 7.5;
        if (!isLt2M) {
            message.error('File must be smaller than 7.5MB!');
            return false;
        } else {
            getS3UploadCredentials(file.name, file, function (result) {
            })
        }

    }
};
function getS3UploadCredentials(filename, file, callback) {
    let json = {
        "cmd": "fileupload:authenticate",
        "fileName": filename,
        "type": "datasheet",
        "auth": {
            key: JSON.parse(sessionStorage.getItem('user')).token
        }
    }
    axios({
        method: 'post',
        url: `https://jahtdfhx64.execute-api.us-west-2.amazonaws.com/IC_CMS_STAGE-01`,
        data: json
    })
        .then(response => {
            message.info(`file upload is in progress ...`);
            document.getElementById("key").value = response.data.reply.message.params.key;
            document.getElementById("acl").value = response.data.reply.message.params.acl;
            document.getElementById("success_action_status").value = response.data.reply.message.params.success_action_status;
            document.getElementById("policy").value = response.data.reply.message.params.policy;
            document.getElementById("x-amz-algorithm").value = response.data.reply.message.params["x-amz-algorithm"];
            document.getElementById("x-amz-credential").value = response.data.reply.message.params["x-amz-credential"];
            document.getElementById("x-amz-date").value = response.data.reply.message.params["x-amz-date"];
            document.getElementById("x-amz-signature").value = response.data.reply.message.params["x-amz-signature"];
            var form = document.getElementById("myform");
            var formData = new FormData(form);
            formData.append("file", file)
            axios({
                method: 'post',
                url: response.data.reply.message.upload_url,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data;boundary=------WebKitFormBoundaryE19zNvXGzXaLvS5C"
                }
            })
                .then(response1 => {
                    if (response1.data === "") {
                        message.success(`file uploaded successfully.`);
                    } else {
                        message.error(`There is some issue, please check it again in some time`);
                    }

                })
                .catch((error1) => {
                    message.error(`There is some issue, please check it again in some time`);
                })
        })
        .catch((error) => {
            message.error(`There is some issue, please try again`);
        })

}

class UploadFileConfig extends React.Component {

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 12 },
        };
        return (
            <div>
                <form id="myform">
                    <input type="hidden" id="key" name="key" />
                    <input type="hidden" id="acl" name="acl" />
                    <input type="hidden" id="success_action_status" name="success_action_status" />
                    <input type="hidden" id="policy" name="policy" />
                    <input type="hidden" id="x-amz-algorithm" name="x-amz-algorithm" />
                    <input type="hidden" id="x-amz-credential" name="x-amz-credential" />
                    <input type="hidden" id="x-amz-date" name="x-amz-date" />
                    <input type="hidden" id="x-amz-signature" name="x-amz-signature" />

                </form>
                <Form >
                    <FormItem
                        {...formItemLayout}
                        label=" "
                        hasFeedback>
                        {getFieldDecorator('name', {
                            rules: [
                                { required: true, message: 'Please Upload File!' },
                            ],
                        })(
                            <Dragger {...props}>
                                <p className="ant-upload-drag-icon">
                                    <Icon type="inbox" />
                                </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">Support for a single upload. Strictly prohibit to upload wrong file type data</p>
                            </Dragger>
                        )}
                    </FormItem>
                </Form>


            </div>

        );
    }
}

const UploadFile = Form.create()(UploadFileConfig);

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile); 


// WEBPACK FOOTER //
// ./src/components/IC/UploadFile/UploadFile.js